import React from 'react'
import { View, Button, Modal } from '@/components'
import { t as translate } from '@lingui/core/macro'
import { useLingui } from '@lingui/react/macro'
import { setI18nLocale } from '@/config'
import { modal } from '@codeleap/modals'

const languageOptions = [
  { label: translate`English`, value: 'en-GB' },
  { label: translate`Brazilian Portuguese`, value: 'pt-BR' }
]

const LanguageModal = modal({ id: 'language' }).content(({ toggle }) => {
  const { i18n } = useLingui()

  function onChangeLocale(newLocale: string) {
    toggle()
    setI18nLocale(newLocale)
  }

  return (
    <View style={['gap:1', 'column']}>
      {languageOptions.map(item => (
        <Button
          debugName="language selector"
          key={item.label}
          style={['link', item.value === i18n.locale && 'link:outline']}
          onPress={() => onChangeLocale(item.value)}
          text={item.label}
        />
      ))}
    </View>
  )
}).props({ style: ['centered', 'box:responsiveness'], title: 'Language', description: 'Select a language' })

export const LanguageSelector = () => {
  const { t } = useLingui()

  return (
    <Button
      text={t`Language: {{language}}`}
      onPress={LanguageModal.toggle}
      debugName='open language selector modal'
      style={['outline']}
      rightIcon='languages'
    />
  )
}